import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const useQuestionPerPageStore = create(
  persist<{
    questionPerPage: number
    setQuestionPerPage: (questionPerPage: number) => void
  }>(
    (set) => ({
      questionPerPage: 1,
      setQuestionPerPage: (questionPerPage: number) => set({ questionPerPage }),
    }),
    {
      name: 'questionPerPage',
      storage: createJSONStorage(() => localStorage),
    }
  )
)

export default useQuestionPerPageStore
